import accountMsGraphSettingsService from "./Campaigns/services/accountMsGraphSettingsService";
import campaignsDataService from "./Campaigns/services/campaignsDataService";
import domainsDataService from "./Domains/services/domainsDataService";
import videoUploaderService from "./Campaigns/services/videoUploaderService";

export const threatDefenceDataServices = {
  campaigns: campaignsDataService,
  videoUploaderService,
  msGraphSettings: accountMsGraphSettingsService,
  domains: domainsDataService,
};
